var map = {
	"./andDownload.png": "1SBK",
	"./bank.png": "BQ/z",
	"./exit_full_screen.png": "G8Fs",
	"./full_screen.png": "n1QG",
	"./homeBg.png": "okBO",
	"./homeBgBottom.png": "KOm9",
	"./landing1.png": "UIpD",
	"./landing2.png": "7rQr",
	"./landing3.png": "gza/",
	"./landing4.png": "OdF1",
	"./language.png": "j12L",
	"./payment_logo.png": "WSBW",
	"./paytm.png": "39D5",
	"./popupDownApp.png": "6/8k",
	"./popupDownAppv.png": "4Z0x",
	"./popupclick.png": "MNkb",
	"./popupclickv.png": "Od7Y",
	"./text.png": "cCQf",
	"./upi.png": "mNW/"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f2LL";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common ^\.\/.*\.png$
// module id = f2LL
// module chunks = 1